import React from 'react';

const IconLogo = () => (
  // <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
  //   <title>Logo</title>
  //   <g transform="translate(-8.000000, -2.000000)">
  //     <g transform="translate(11.000000, 5.000000)">
  //       <path
  //         d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
  //         fill="currentColor"
  //       />
  //       <polygon
  //         id="Shape"
  //         stroke="currentColor"
  //         strokeWidth="5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         points="39 0 0 22 0 67 39 90 78 68 78 23"
  //       />
  //     </g>
  //   </g>
  // </svg>
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    width="500"
    zoomAndPan="magnify"
    viewBox="0 0 375 374.999991"
    height="500"
    preserveAspectRatio="xMidYMid meet"
    version="1.0">
    <defs>
      <g />
      <clipPath id="bd1f0a69be">
        <path
          d="M 0 147.3125 L 375 147.3125 L 375 228.148438 L 0 228.148438 Z M 0 147.3125 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <g fill="#64ffda" fillOpacity="1">
      <g transform="translate(13.981463, 320.852301)">
        <g>
          <path d="M 126.695312 -135.46875 C 147.355469 -152.621094 159.441406 -178.152344 159.441406 -211.289062 L 159.441406 -261.382812 C 159.441406 -264.890625 157.6875 -269.765625 152.425781 -269.765625 L 116.367188 -269.765625 C 111.882812 -269.765625 107.398438 -266.644531 107.398438 -260.800781 L 107.398438 -217.136719 C 107.398438 -184.195312 98.042969 -161.390625 65.882812 -158.664062 L 65.882812 -262.164062 C 65.882812 -266.839844 63.933594 -269.765625 59.449219 -269.765625 L 20.660156 -269.765625 C 16.371094 -269.765625 14.035156 -266.839844 14.035156 -262.164062 L 14.035156 -7.40625 C 14.035156 -2.730469 16.179688 0 20.660156 0 L 59.644531 0 C 64.128906 0 65.882812 -2.730469 65.882812 -7.40625 L 65.882812 -109.738281 C 100.1875 -108.179688 110.128906 -84.984375 110.128906 -51.261719 L 110.128906 -8.769531 C 110.128906 -2.921875 114.417969 0 118.898438 0 L 155.152344 0 C 160.222656 0 162.171875 -4.679688 162.171875 -8.1875 L 162.171875 -57.304688 C 162.171875 -91.804688 149.113281 -118.316406 126.695312 -135.46875 Z M 126.695312 -135.46875 " />
        </g>
      </g>
    </g>
    <g fill="#64ffda" fillOpacity="1">
      <g transform="translate(205.078205, 320.852301)">
        <g>
          <path d="M 98.042969 -191.601562 C 98.042969 -186.144531 98.824219 -184.195312 103.695312 -184.195312 L 138.585938 -184.195312 C 144.824219 -184.195312 146.1875 -186.144531 146.1875 -191.601562 L 146.1875 -202.714844 C 146.1875 -245.789062 117.339844 -273.859375 76.992188 -273.859375 C 49.703125 -273.859375 7.796875 -254.5625 7.796875 -203.882812 C 7.796875 -159.246094 26.117188 -146.382812 66.855469 -113.246094 C 90.832031 -93.753906 100.96875 -84.984375 100.96875 -66.078125 C 100.96875 -51.847656 91.027344 -42.882812 78.746094 -42.882812 C 68.804688 -42.882812 56.527344 -49.117188 56.527344 -68.609375 L 56.527344 -77.382812 C 56.527344 -83.230469 55.355469 -85.375 49.898438 -85.375 L 14.425781 -85.375 C 8.964844 -85.375 7.796875 -82.644531 7.796875 -76.019531 L 7.796875 -65.6875 C 7.796875 -29.042969 31.382812 4.289062 78.355469 4.289062 C 121.433594 4.289062 150.28125 -26.898438 150.28125 -63.347656 C 150.28125 -112.660156 121.238281 -133.90625 84.789062 -162.171875 C 67.441406 -175.621094 55.941406 -184 55.941406 -202.519531 C 55.941406 -220.257812 67.246094 -227.078125 76.992188 -227.078125 C 91.027344 -227.078125 98.042969 -215.96875 98.042969 -202.519531 Z M 98.042969 -191.601562 " />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
